import angular from 'angular'
import kickerComponent from './kicker.component'

export default angular
  .module('ellipsis.kicker', [])
  .component('kicker', kickerComponent)
